<!-- modal-disclaimer -->
<div class="modal fade" id="modal-disclaimer" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-disclaimer" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Disclaimer</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<ul class="modal-term-ul">
					<li>
						Investment in securities markets are subject to market risks, read all the related documents carefully
						before investing.
					</li>
					<li>
						Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.
					</li>
					<li>
						Mutual fund investments are subject to market risks, read all scheme related documents carefully.
					</li>
					<li>
						<b>SEBI Registration No.:</b> INZ000186937 (NSE, BSE, MSEI, MCX) <br />
						<b>NSE Trading Member Code:</b> 11094 <br />
						<b>BSE Clearing Number:</b> 393 <br />
						<b>MSEI Trading Member Code:</b> 30000 <br />
						<b>MCX Member Code:</b> 56015 IN-DP-372-2018 (CDSL, NSDL) <br />
						<b>AMFI Reg No.: </b> ARN -13549 <br />
						<b>PFRDA Reg. No.: </b> POP 11092018 <br />
						<b>IRDA Corporate Agent Licence No.: </b> CA0062 <br />
						<b>Research Analyst Reg. No.: </b> INH000002475 <br />
						<b>Investment Adviser: </b> INA000011538 CIN-U67120MH2000PLC152193
					</li>
					<li>
						<b>Registered Address:</b> I Think Techno Campus, Building, B, Alpha, Office Floor 8, Near Kanjurmarg Station,
						Kanjurmarg (East), Mumbai -400 042. Tel: <a href="tel:02230753400" target="_blank" class="btn common-link2 text-hdfc-blue">022 30753400</a>.
						<br />
						<b>Compliance Officer:</b> <br />
						Mr. Murli V Karkera. Ph: <a href="tel: 02230453600" target="_blank" class="btn common-link2 text-hdfc-blue"> 022 30453600</a>, <br />
						Email: <a href="mailto:complianceofficer@hdfcsec.com" target="_blank" class="btn common-link2 text-hdfc-blue">complianceofficer@hdfcsec.com</a>.
					</li>
					<li>
						<b>Disclaimer</b> : HDFC Securities Ltd is a financial services intermediary and is engaged as a distributor
						of financial products & services like Corporate FDs & Bonds, Insurance, MF, NPS, Real Estate services,
						Loans, NCDs, IPOs, E-Will & E-Tax in strategic distribution partnerships.
					</li>
					<li>
						Customers need to check products & features before investing since the contours of the product rates may
						change from time to time. HDFC securities Ltd is not liable for any loss or damage of any kind arising out
						of investments in these products.
					</li>
					<li>
						Investments in Equity, Currency, Futures & Options, Commodities are subject to market risk.
					</li>
					<li>
						Clients should read the Risk Disclosure Document issued by SEBI & relevant exchanges & the T&C on <a href="https://www.hdfcsec.com/" class="btn common-link2 text-hdfc-blue"
																													   target="_blank">www.hdfcsec.com</a> before investing. Equity SIP is not an approved product of Exchange
						and any dispute related to this will not be dealt at Exchange platform.
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>


<!-- modal-terms -->
<div class="modal fade" id="modal-terms" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p><strong>Offer Details - We are offering a 100% discount ( Rs 0 ) on the 6
					months Tickertape Pro subscription plan which is worth Rs. 700.</strong></p><br/>
				<p><strong> Redemption Details & T&C</strong></p>
				<ul class="modal-term-ul">
					<li>1. To avail 6-month FREE offer, the user will receive a link on email when he/she open an account with HDFC sec</li>
					<li>2. User has to click on link to claim the offer. (The offer will already be loaded in the link)</li>

					<li>3. The Value of offer is Rs 700 which is offered to customer at Rs 0.</li>
					<li>4. Offer only available on the 6 MONTH plan.</li>
					<li>5. Please refer to <a href="https://www.timesprime.com/terms-and-conditions" target="_blank" class="btn common-link2 text-hdfc-blue">https://www.tickertape.in/meta/terms</a> for terms and conditions.</li>
					<li>6. Both Tickertape and HDFC Securities reserve the right to discontinue this offer with prior notice.</li>
					<li>7. Activate the offer within 15 days from the date of the received link to avoid expiry.</li>
					<li>8. Post the offer completion period, the subscription fee will be depending on the prevailing price at that time for which customer directly needs to buy
					from <a href="https://www.tickertape.in/" target="_blank" class="btn common-link2 text-hdfc-blue">www.Tickertape.in</a>.<li>
					<li>9. The offer cannot be clubbed with any other discount offers.</li>
					<li>10. This offer is valid only for new customers who have successfully
					opened Demat & trading account with HDFC Securities within the given
					offer period.</li>
					<li>11. The offer is not valid for existing HDFC securities account holders.</li>
				
				</ul>
			</div>
		</div>
	</div>
</div>


<!-- modal-terms-investing-hub -->
<div class="modal fade" id="modal-terms-investing-hub" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p><strong> Investing Hub to offer HSL customers 3-months of FREE access to the	platform (worth INR 1,050) via a coupon code </strong></p>
				<p><strong>Value of offer: - The value of this offer is INR 1,050</strong></p><br/>
				<p><strong> Redemption & T&C:</strong></p>

				<ul class="modal-term-ul">
					<li>1. To avail this 3-month FREE offer, create an account on  <a href="https://www.investingHub.in" target="_blank" class="btn common-link2 text-hdfc-blue">InvestingHub.in</a> and enter your details.</li>
					<li>2. After applying the coupon code shared with customer, the monthly fee will change to INR 0 and you will not be charged anything for this offer period.</li>
					<li>3. Customers will have to enter their credit card details during registration, however, they will not be charged anything during this period and can cancel anytime.</li>
					<li>4. During the registration process, INR 1 will be deducted for authentication purposes, however, this will be reversed within 7 days.</li>
					<li>5. Post the offer period, if users feel that the knowledge gives them an edge and they continue to use the service, the subscription fee will be autodebited depending on the prevailing price at that time.</li>
					<li>6. Both <a href="https://www.investingHub.in" target="_blank" class="btn common-link2 text-hdfc-blue">InvestingHub.in</a> and HDFC Securities reserve the right to discontinue this offer with prior notice.</li>
					<li>7. The offer cannot be clubbed with any other discount offer.</li>
					<li>8. This offer is valid only for new customers who have successfully opened demat & trading account with HDFC Securities within the given offer period.</li>
					<li>9. The offer is not valid for existing HDFC securities account holders.</li>
				</ul>
			</div>
		</div>
	</div>
</div>

<!-- modal-terms-timesprime -->
<div class="modal fade" id="modal-terms-timesprime" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p>Offers - Get complimentary 12 month Times Prime membership and enjoy benefits worth Rs. 60000</p>
				<p>Redemption journey and terms and conditions:</p>
				<br/>
				<ul class="modal-term-ul">
				<li>1. Each e-code will entitle the customers to avail the complimentary 12 months Times Prime membership.</li>
				<li>2. Partner to further roll out e-codes to its eligible customers via its channels.</li>
				<li>3. Visit www.timesprime.com or download the app.</li>
				<li>4. At the signup page, enter the e-code received and fill in your necessary information</li>
				<li>5. The offer cannot be clubbed with any other discount offer.</li>
				<li>6. The e-code is applicable once per user.</li>
				<li>7. Activate the ecode within 30 days from the date of received ecode to avoid expiry. The offers/memberships must be unlocked within the Times Prime Membership period.</li>
				<li>8. In case of any issues related to the redemption of the e-code, please contact support@timesprime.com </li>
				<li>9. Times Prime reserves the right to terminate, modify, extend the timelines and features, at any time at its absolute discretion.</li>
				<li>10. All Times Prime terms and conditions (as mentioned in the T&Cs on <a href="https://www.timesprime.com/terms-and-conditions" target="_blank" class="btn common-link2 text-hdfc-blue">https://www.timesprime.com/terms-and-conditions</a>) are applicable to the membership availed under this offer.</li>
				<li>11. Both Times prime and HDFC securities reserve the right to discontinue this offer without prior notice.</li>
										

					

				</ul>
			</div>
		</div>
	</div>
</div>


<!-- modal-terms-all -->
<div class="modal fade" id="modal-terms-all" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p><b>Times Prime</b></p>
				<p>Offers - Get complimentary 12 month Times Prime membership and enjoy benefits worth Rs. 60000</p>
				<p>Redemption journey and terms and conditions:</p>
				<br/>
				<ul class="modal-term-ul">
				<li>1. Each e-code will entitle the customers to avail the complimentary 12 months Times Prime membership.</li>
				<li>2. Partner to further roll out e-codes to its eligible customers via its channels.</li>
				<li>3. Visit www.timesprime.com or download the app.</li>
				<li>4. At the signup page, enter the e-code received and fill in your necessary information</li>
				<li>5. The offer cannot be clubbed with any other discount offer.</li>
				<li>6. The e-code is applicable once per user.</li>
				<li>7. Activate the ecode within 30 days from the date of received ecode to avoid expiry. The offers/memberships must be unlocked within the Times Prime Membership period.</li>
				<li>8. In case of any issues related to the redemption of the e-code, please contact support@timesprime.com </li>
				<li>9. Times Prime reserves the right to terminate, modify, extend the timelines and features, at any time at its absolute discretion.</li>
				<li>10. All Times Prime terms and conditions (as mentioned in the T&Cs on 
					<a href="https://www.timesprime.com/terms-and-conditions" target="_blank" class="btn common-link2 text-hdfc-blue">https://www.timesprime.com/terms-and-conditions</a>) are applicable to the membership availed under this offer.</li>
				<li>11. Both Times prime and HDFC securities reserve the right to discontinue this offer without prior notice.</li>
			</ul>
		<hr>
				<p><b>Tickertape</b></p>
				<p><strong>Offer Details - We are offering a 100% discount ( Rs 0 ) on the 6
					months Tickertape Pro subscription plan which is worth Rs. 700.</strong></p><br/>
				<p><strong> Redemption Details & T&C</strong></p>
				<ul class="modal-term-ul">
					<li>1. To avail 6-month FREE offer, the user will receive a link on email when he/she open an account with HDFC sec</li>
					<li>2. User has to click on link to claim the offer. (The offer will already be loaded in the link)</li>

					<li>3. The Value of offer is Rs 700 which is offered to customer at Rs 0.</li>
					<li>4. Offer only available on the 6 MONTH plan.</li>
					<li>5. Please refer to <a href="https://www.timesprime.com/terms-and-conditions" target="_blank" class="btn common-link2 text-hdfc-blue">https://www.tickertape.in/meta/terms</a>for terms and conditions.</li>
					<li>6. Both Tickertape and HDFC Securities reserve the right to discontinue this offer with prior notice.</li>
					<li>7. Activate the offer within 15 days from the date of the received link to avoid expiry.</li>
					<li>8. Post the offer completion period, the subscription fee will be depending on the prevailing price at that time for which customer directly needs to buy
					from <a href="https://www.tickertape.in/" target="_blank" class="btn common-link2 text-hdfc-blue">www.Tickertape.in</a>.<li>
					<li>9. The offer cannot be clubbed with any other discount offers.</li>
					<li>10. This offer is valid only for new customers who have successfully
					opened Demat & trading account with HDFC Securities within the given
					offer period.</li>
					<li>11. The offer is not valid for existing HDFC securities account holders.</li>
				
				</ul>
				
				<hr>


				<p><b>Investing Hub</b></p>
				<p><strong> Investing Hub to offer HSL customers 3-months of FREE access to the	platform (worth INR 1,050) via a coupon code </strong></p>
				<p><strong>Value of offer: - The value of this offer is INR 1,050</strong></p><br/>
				<p><strong> Redemption & T&C:</strong></p>

				<ul class="modal-term-ul">
					<li>1. To avail this 3-month FREE offer, create an account on  <a href="https://www.investingHub.in" target="_blank" class="btn common-link2 text-hdfc-blue">InvestingHub.in</a> and enter your details.</li>
					<li>2. After applying the coupon code shared with customer, the monthly fee will change to INR 0 and you will not be charged anything for this offer period.</li>
					<li>3. Customers will have to enter their credit card details during registration, however, they will not be charged anything during this period and can cancel anytime.</li>
					<li>4. During the registration process, INR 1 will be deducted for authentication purposes, however, this will be reversed within 7 days.</li>
					<li>5. Post the offer period, if users feel that the knowledge gives them an edge and they continue to use the service, the subscription fee will be autodebited depending on the prevailing price at that time.</li>
					<li>6. Both <a href="https://www.investingHub.in" target="_blank" class="btn common-link2 text-hdfc-blue">InvestingHub.in</a> and HDFC Securities reserve the right to discontinue this offer with prior notice.</li>
					<li>7. The offer cannot be clubbed with any other discount offer.</li>
					<li>8. This offer is valid only for new customers who have successfully opened demat & trading account with HDFC Securities within the given offer period.</li>
					<li>9. The offer is not valid for existing HDFC securities account holders.</li>
				</ul>

			</div>
		</div>
	</div>
</div>




<!-- modal-terms-gpay-->
<div class="modal fade" id="modal-terms-gpay" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">

				<p><strong>Offer - Amazon voucher worth ₹500/- & Bloomberg Quint subscription
					for 3 month’s worth ₹1400/-</strong></p><br/>

				<p><strong>Redemption journey and Terms & Conditions:</strong></p><br/>
				<ul class="modal-term-ul">
					<li>1) This offer is exclusively available for Google Pay customers.
					<li>2) This offer is valid only for new customers from Google Pay who have a validated e-code & have successfully opened demat & trading account with HDFC Securities within the given offer period.</li>
					<li>3) Customer to receive Amazon voucher code & Bloomberg Quint subscription code within 15- 20 working days of successful account opening with HDFC Securities.</li>
					<li>4) Post successful demat & trading account opening with HDFC Securities, the customer will get a benefit of worth Rs.1900/-. Once he successfully claims the Amazon voucher worth ₹500/- & Bloomberg Quint subscription for 3 month’s worth ₹1400/-</li>
					<li>5) Customer needs to claim the voucher code within 30 days of receiving the code for Amazon & Bloomberg Quint.</li>
					<li>6) The offer cannot be clubbed with any other discount offer and is only applicable for new account holders via the Google Pay channel.</li>
					<li>7) The e-code is applicable once per user.</li>
					<li>8) To redeem the voucher, visit <a href="https://www.amazon.com/" target="_blank" class="btn common-link2 text-hdfc-blue">www.amazon.com</a> 
					or download the app and follow the on-screen instructions.</li>
					<li>9) To redeem the voucher, visit <a href="https://www.bloombergquint.com/" target="_blank" class="btn common-link2 text-hdfc-blue">www.bloombergquint.com</a> or download the app and follow the on-screen instructions.</li>
					<li>10) In case of any issues related to the redemption of the e-code, the customer can contact the Amazon/Bloomberg Quint support team.</li>
					<li>11) Any grievances related to the above scheme/offer/campaign would not be entertained or under investor protection or grievance redressal measures of the Exchange. (re-word) The grievance related to the scheme shall be addressed by Company’s redressal mechanism and will not be governed by any other grievance redressal forum of regulator/s.</li>
					<li>12) For detailed disclaimer and product terms and conditions refer to our website <a href="https://www.hdfcsec.com/" target="_blank" class="btn common-link2 text-hdfc-blue">www.hdfcsec.com</a></li>
					<li>13) The offer is not valid for existing HDFC securities account holders.</li>
				</ul>

			</div>
		</div>
	</div>
</div>


<!-- modal-terms-google-pay-->
<div class="modal fade" id="modal-terms-google-pay" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">

				<p><strong>Offer Details Google Pay</strong></p><br/>

				<p><strong>Brand Voucher worth ₹500 & Premia subscription worth Rs 2999 for 1 Year. - Total Benefit Rs 3499 </strong></p><br/>
				<ul class="modal-term-ul">
					<li>1. The offers are exclusively available for Google Pay customers. </li>
					<li>2. Offer is valid only for new customers from Google Pay who have a validated e-code. </li>
					<li>3. Offer will be given after the successful account opening and completing a successful trade order within 20 trading days of the account opening. ( Mutual Fund order will not be considered as a trade order). </li>
					<li>4. Customer to receive one time redeemable Brand voucher code & Premia subscription for 1 Year within 15-20 working days ( Excluding Saturday/Sunday and public holiday) of successful account opening with HDFC Securities and placing a successful trade order within 20 days of account opening. </li>
					<li>5. Post successful demat/ trading account opening and placing a trade order within 20 trading days of account opening with HDFC Securities, the customer will get a benefit worth Rs 3499. Once he successfully claims the Brand voucher worth ₹500 & Premia subscription for 1 Year worth ₹2999. </li>
					<li>6. Customer needs to claim the brand voucher code within 60 days of receiving the code for brand voucher & Premia subscription will be activated from our side within 15-20 Working days ( Excluding Saturday/Sunday and public holiday). </li>
					<li>7. The offer cannot be clubbed with any other discount offer and is only applicable for new account holders via the Google Pay channel. </li>
					<li>8. The brand voucher e-code is applicable once per user and will send the brand voucher only on registered email id and mobile no which the customer has used at the time of account opening. </li>
					<li>9. To redeem the brand voucher, follow our communication for the redemption journey and follow the on-screen instructions accordingly. </li>
					<li>10. The validity of the Premia subscription will be for 1 Year from the date of activation in which no RM services will be provided for accounts opened from Google Pay Channel. After 1 Year customer has to subscribe for premia services accordingly by paying the subscription charges. Click here for Premia T&C - <a href="https://www.hdfcsec.com/premia" target="_blank" class="btn common-link2 text-hdfc-blue">www.hdfcsec.com/premia</a> </li>
					<li>11. In case of any issues related to the redemption of the e-code, the customer can contact the support team ( mentioned in our communication), and for Premia services customer can contact HDFC securities </li>
					<li>12. Any grievances related to the above scheme/offer/campaign would not be entertained or under investor protection or grievance redressal measures of the Exchange. The grievance related to the scheme shall be addressed by Company’s redressal mechanism and will not be governed by any other grievance redressal forum of regulator/s. </li>					
					<li>13. For detailed disclaimer and product terms and conditions refer to our website <a href="https://www.hdfcsec.com" target="_blank" class="btn common-link2 text-hdfc-blue">www.hdfcsec.com</a>www.hdfcsec.com </li>
					<li>14. The offer is not valid for existing HDFC securities account holders. </li>
					<li>15. HDFC Securities reserves the right to discontinue this offer with prior notice. </li>
					<li>16. Customer can claim any available brand voucher worth Rs 500 from the e-code given from HDFC securities</li>
				</ul>

			</div>
		</div>
	</div>
</div>

<!-- modal-terms-phone-pay-->
<div class="modal fade" id="modal-terms-phone-pay" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">

				<p><strong>Offer Details for PhonePe </strong></p><br/>

				<p><strong>Brand Voucher worth ₹500 & Premia subscription worth Rs 2999 for 1 Year. - Total Benefit Rs 3499 </strong></p><br/>
				<ul class="modal-term-ul">					
						<li>1. The offers are exclusively available for PhonePe customers. </li>
						<li>2. Offer is valid only for new customers from PhonePe who have a validated e-code. </li>
						<li>3. Offer will be given after the successful account opening and completing a successful trade order within 20 days of the account opening. ( Mutual Fund order will not be considered as a trade order). </li>
						<li>4. Customer to receive one time redeemable Brand voucher code & Premia subscription for 1 Year within 15-20 working days ( Excluding Saturday/Sunday and public holiday) of successful account opening with HDFC Securities and placing a successful trade order within 20 days of account opening. </li>
						<li>5. Post successful demat/ trading account opening and placing a trade order within 20 days of account opening with HDFC Securities, the customer will get a benefit worth Rs 3499. Once he successfully claims the Brand voucher worth ₹500 & Premia subscription for 1 Year worth ₹2999. </li>
						<li>6. Customer needs to claim the brand voucher code within 60 days of receiving the code for brand voucher & Premia subscription will be activated from our side within 15-20 Working days ( Excluding Saturday/Sunday and public holiday). </li>
						<li>7. The offer cannot be clubbed with any other discount offer and is only applicable for new account holders via the PhonePe channel. </li>
						<li>8. The brand voucher e-code is applicable once per user and will send the brand voucher only on registered email id and mobile no which the customer has used at the time of account opening. </li>
						<li>9. To redeem the brand voucher, follow our communication for the redemption journey and follow the on-screen instructions accordingly. </li>
						<li>10. The validity of the Premia subscription will be for 1 Year from the date of activation in which no RM services will be provided for accounts opened from PhonePe Channel. After 1 Year customer has to subscribe for premia services accordingly by paying the subscription charges. Click here for Premia T&C - <a href="https://www.hdfcsec.com/premia" target="_blank" class="btn common-link2 text-hdfc-blue">www.hdfcsec.com/premia</a> </li>
						<li>11. In case of any issues related to the redemption of the e-code, the customer can contact the support team ( mentioned in our communication), and for Premia services customer can contact HDFC securities </li>
						<li>12. Any grievances related to the above scheme/offer/campaign would not be entertained or under investor protection or grievance redressal measures of the Exchange. The grievance related to the scheme shall be addressed by Company’s redressal mechanism and will not be governed by any other grievance redressal forum of regulator/s. </li>
						<li>13. For detailed disclaimer and product terms and conditions refer to our website <a href="https://www.hdfcsec.com" target="_blank" class="btn common-link2 text-hdfc-blue">www.hdfcsec.com</a>www.hdfcsec.com </li>
						<li>14. The offer is not valid for existing HDFC securities account holders. </li>
						<li>15. HDFC Securities reserves the right to discontinue this offer with prior notice. </li>
						<li>16. Customer can claim any available brand voucher worth Rs 500 from the e-code given from HDFC securities.</li>
				</ul>

			</div>
		</div>
	</div>
</div>
<!-- modal-terms-offer2-gpay-->
<div class="modal fade" id="modal-terms-offer2-gpay" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">

				<p><strong>Details of the Offer:</strong></p><br />
				<ul class="modal-term-ul">
					<li>1. Zero Account Opening Charges.</li>
					<li>2. FREE Brokerage on Equity Trades for 30 Calendar days.</li>
					<li>3. FREE Brokerage on Derivatives Trades for 30 Calendar days. </li>
					<li>
						4. Same day pay out up to Rs.5 Lakh per at zero incremental cost.
					</li>
					<li>
						5. Zero Interest on Derivatives Margin paid as collateral.
					</li>
					<p><strong>Detailed Terms & Conditions for the above Offer:</strong></p><br />
					<li>
						1. The offers are exclusively available for Google Pay customers. 
					
					</li>
					<li>
						2. Offer is valid only for new customers from Google Pay who have validated e-code. 
					</li>
					<li>
						3. Offer will be applicable after the successful account opening.
					</li>
					<li>
						4. The offer cannot be clubbed with any other discount offer and is only applicable for new 
						account holders via the Google Pay channel.
					</li>
					<li>5. Any grievances related to the above scheme/offer/campaign would not be entertained or 
						under investor protection or grievance redressal measures of the Exchange. The grievance 
						related to the scheme shall be addressed by Company’s redressal mechanism and will not be 
						governed by any other grievance redressal forum of regulator/s. </li>
					<li>6. For detailed disclaimer and product terms and conditions refer to our 
						website<a href="https://www.hdfcsec.com/article/disclaimer-1795" target="_blank" class="btn common-link2 text-hdfc-blue">
							https://www.hdfcsec.com/article/disclaimer-1795
						</a>.</li>
					<li>
						7. The offer is not valid for existing HDFC securities account holders.
					</li>
					<li>
						8. Account Opening Application must be logged in and opened during the campaign period 
						only.
					</li>
					<li>9. At the time of account opening, customer must continue with the said offer. If customers 
						avail for another brokerage scheme at any point of time, then the above offer stands 
						forfeited for the remaining days of the scheme and above benefits may not be applicable to 
						other offer selected and customer cannot claim any refund / concern under any 
						circumstances.</li>
						<li>
							10.  In order to avail Derivatives benefits, Derivatives privilege needs to be opted-in at the time 
							of account opening itself. If the Derivatives privilege is taken post account opening, then the 
							Derivatives benefit will not be extended.
						</li>
						<li>
							11. FREE Brokerage offer on Equity Cash Segment as well as on Derivatives will be valid from 30 
							calendar days from the date of account opening or utilization of free Volume, whichever is 
							earlier.
						</li>
						<li>
							12. Customers must choose Equity Cash and Derivatives, both while account opening to be 
							eligible for FREE Brokerage Offer.
						</li>
						<li>
							13. Maximum limit for Equity Cash volume is Rs. 10 Cr across Intraday and Delivery transactions, 
							whereas maximum limit for Derivatives segment is 1 lakh lots across Options and Future 
							contract.
						</li>
						<li>
							14. Nominal Brokerage of 0.01 paisa will be levied on each Order / Trade.
						</li>
						<li>
							15. Once the volume is exhausted or validity is completed, Standard Brokerage rate will be 
							applicable for Equity Cash Segment, whereas for Derivatives it will be Rs. 20 per lot and 
							0.01% for Future Contract.
						</li>
						<li>
							16. GST, STT and other statutory fees will be charged separately and will be paid by me for 
							transactions done in my trading account, as per the regulatory requirements.
						</li>
						<li>
							17. Any research service is only an add-on service provided by HDFC securities Limited and does 
							not constitute an offer/invitation and/or a solicitation by HDFC securities Limited to 
							purchase/sell or otherwise deal in securities in any manner.
						</li>
						<li>
							18. Any communication by HDFC Securities Ltd. is only by way of information. Any decision, 
							action or omission thereon shall be entirely at the client's risk and should be based solely on 
							my (the client's) own verification of all relevant facts, financial and other circumstances, a 
							proper evaluation thereof and the client's investment objectives and I/we shall not hold 
							HDFC securities Limited and/or any of its representatives liable for the same. HDFC 
							Securities Ltd should not be held responsible for any delay of information sent by SMS / 
							Email.
						</li>
						<li>
							19. This scheme will be co-terminus with the client-member agreement, Power of Attorney / 
							DDPI / Bank Mandate. Rights and obligations executed/confirmed by me with/to HDFC 
							securities Limited in respect of my captioned trading account..
						</li>
						<li>
							20. Customer will not hold HDFC Securities Ltd. responsible for, or liable for, any actions, claims, 
							demands, losses, damages, costs, charges and expenses which they may suffer, sustain or 
							incur by way of above offer.
						</li>

						<li>
						21. Minimum brokerage of Rs. 25 per order will be applicable for equity segment i.e. both 
						intraday and delivery (apart from free volume) based transaction. For the stocks below Rs. 
						10, brokerage of 5 paisa per share will be applicable.
					</li>
					<li>
						22. Standard brokerage rate will be applicable for all the other segment, which are not 
						mentioned in the scheme or T&C.
					</li>
					<li>
						23. If any fraudulent activity found, the final decision of extending the said offer benefits would 
						be HDFC securities.
					</li>
					<li>
						24. For detailed disclaimer and product terms and conditions refer our website
						<a href="www.hdfcsec.com" target="_blank" class="btn common-link2 text-hdfc-blue">
							www.hdfcsec.com
						</a>
						
					</li>
					<li>
						25. HDFC Securities reserves the right to discontinue this offer with prior notice.
					</li>
					<li>
						26. Investments in Securities Markets are subject to market risks, read all related documents 
						carefully before investing.
					</li>
					<li>
						27. The dispute related to the offer will not be dealt on the Exchange platform.
					</li>
				</ul>

			</div>
		</div>
	</div>
</div>

<!-- modal-terms-phonepe-->
<div class="modal fade" id="modal-terms-phonepe" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p><strong>Offer - Amazon voucher worth ₹500/- & Bloomberg Quint subscription for 3 month’s worth ₹1400/-</strong></p><br/>

				<p><strong>Redemption journey and Terms & Conditions:</strong></p><br/>
				<ul class="modal-term-ul">
					<li>1) This offer is exclusively available for Phone Pe customers.</li>
					<li>2) This offer is valid only for new customers from Phone Pe who have a validated e-code & have successfully opened demat & trading account with HDFC Securities within the given offer period.</li>
					<li>3) Customer to receive Amazon voucher code & Bloomberg Quint subscription code within 15- 20 working days of successful account opening with HDFC Securities.</li>
					<li>4) Post successful demat & trading account opening with HDFC Securities, the customer will get a benefit of worth Rs.1900/-. Once he successfully claims the Amazon voucher worth ₹500/- & Bloomberg Quint subscription for 3 month’s worth ₹1400/-</li>
					<li>5) Customer needs to claim the voucher code within 30 days of receiving the code for Amazon & Bloomberg Quint.</li>
					<li>6) The offer cannot be clubbed with any other discount offer and is only applicable for new account holders via the Phone Pe channel.</li>
					<li>7) The e-code is applicable once per user.</li>
					<li>8) To redeem the voucher, visit <a href="www.amazon.com" target="_blank" class="btn common-link2 text-hdfc-blue">www.amazon.com</a> or download the app and follow the on-screen instructions.</li>
					<li>9) To redeem the voucher, visit  <a href="www.bloombergquint.com" target="_blank" class="btn common-link2 text-hdfc-blue">www.bloombergquint.com</a> or download the app and follow the on-screen instructions.</li>
					<li>10) In case of any issues related to the redemption of the e-code, the customer can contact the Amazon/Bloomberg Quint support team.</li>
					<li>11) Any grievances related to the above scheme/offer/campaign would not be entertained or under investor protection or grievance redressal measures of the Exchange. (re-word) The grievance related to the scheme shall be addressed by Company’s redressal mechanism and will not be governed by any other grievance redressal forum of regulator/s.</li>
					<li>12) For detailed disclaimer and product terms and conditions refer to our website <a href="www.hdfcsec.com" target="_blank" class="btn common-link2 text-hdfc-blue">www.hdfcsec.com</a></li>
					<li>13 ) The offer is not valid for existing HDFC securities account holders.</li>
				</ul>

			</div>
		</div>
	</div>
</div>

<!-- modal-terms-offer2-phonepe-->
<div class="modal fade" id="modal-terms-offer2-phonepe" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">

				<p><strong>Offer - Amazon voucher worth ₹500/- & Premia subscription worth ₹2999/- for 1 year.
					Total benefit ₹3499/-</strong></p><br/>

				<p><strong>Redemption journey and Terms & Conditions:</strong></p><br/>
				<ul class="modal-term-ul">
					<li>1) This offer is exclusively available for Phone Pe customers.
					<li>2) This offer is valid only for new customers from Phone Pe who have a validated e-code & have
						successfully opened demat & trading account with HDFC Securities within the given offer period.</li>
					<li>3) Customer to receive one time redeemable Amazon voucher code & Premia subscription for 1
						Year within 15- 20 working days of successful account opening with HDFC Securities.</li>
					<li>4) Post successful demat & trading account opening with HDFC Securities, the customer will get a
						benefit worth Rs 3499. Once he successfully claims the Amazon voucher worth ₹500 &
						Premia subscription for 1 Year worth ₹2999.</li>
					<li>5) Customer needs to claim the voucher code within 30 days of receiving the code for Amazon &
						Premia subscription will be activated from our side within 15-20 Working days.</li>
					<li>6) The offer cannot be clubbed with any other discount offer and is only applicable for new
						account holders via the Phone Pe channel.</li>
					<li>7) The e-code is applicable once per user.</li>
					<li>8) To redeem the amazon voucher, visit <a href="https://www.amazon.in/" target="_blank" class="btn common-link2 text-hdfc-blue">www.amazon.in</a>  or download the app and follow the
						on-screen instructions.</li>
					<li>9) The validity of Premia subscription will be for 1 Year from the date of activation,After that
						customer has to subscribe for premia services accordingly by paying the subscription charges.
						Click here for Premia T&C - <a href="https://www.hdfcsec.com/premia" target="_blank" class="btn common-link2 text-hdfc-blue">www.hdfcsec.com/premia</a>.</li>
					<li>10) In case of any issues related to the redemption of the e-code, the customer can contact the
						Amazon support team and for Premia one can contact HDFC securities.</li>
					<li>11) Any grievances related to the above scheme/offer/campaign would not be entertained or under
						investor protection or grievance redressal measures of the Exchange. The grievance related to the
						scheme shall be addressed by Company’s redressal mechanism and will not be governed by any
						other grievance redressal forum of regulator/s.</li>
					<li>12) For detailed disclaimer and product terms and conditions refer to our website
						<a href="https://www.hdfcsec.com/" target="_blank" class="btn common-link2 text-hdfc-blue">www.hdfcsec.com</a>.</li>
					<li>13) The offer is not valid for existing HDFC securities account holders.</li>
					<li>14) HDFC Securities reserves the right to discontinue this offer with prior notice.</li>
				</ul>

			</div>
		</div>
	</div>
</div>

<!-- modal-terms-Bloomberg -->
<!-- <div class="modal fade" id="modal-terms-blu" data-backdrop="static" data-keyboard="false" tabindex="-1"
	 aria-labelledby="modal-terms" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Terms & Condition </h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p><strong> Offer Details – Bloomberg 3 month subscription free which is worth Rs 1400.</strong></p>
				<p>Redemption journey and terms and conditions:</p>
				<br/>
				<ul class="modal-term-ul">
					<li>1. Each e-code will entitle the customers to avail the complimentary for 3 months of Bloomberg Quint.</li>
					<li>2. Hdfcsec to further roll-out e-codes to its eligible customers within 15 days of account opening.</li>
					<li>3. Visit <a href="www.https://www.bloombergquint.com" target="_blank" class="btn common-link2 text-hdfc-blue">www.https://www.bloombergquint.com</a> or download the app.</li>
					<li>4. At the signup page/checkout, enter the e-code received and fill in your necessary information.</li>
					<li>5. The offer cannot be clubbed with any other discount offer.</li>
					<li>6. The e-code is applicable once per user.</li>
					<li>7. Activate the e-code within 30 days from the date of the received e-code to avoid expiry. The offers/memberships must be unlocked within the Bloomberg quint period.</li>
					<li>8. In case of any issues related to the redemption of the e-code, please contact www.bloombergquint.com</li>
					<li>9. All Bloomberg quint terms and conditions (as mentioned in the T&Cs on  <a href="https://www.bloombergquint.com/bq-blue-subscription" target="_blank" class="btn common-link2 text-hdfc-blue">https://www.bloombergquint.com/bq-blue-subscription</a> ) are applicable to the membership availed under this offer. </li>
					<li>10. Both Bloomberg Quint and HDFC securities reserve the right to discontinue this offer without prior notice.</li>
					<li>11. The offer is not valid for existing HDFC securities account holders.</li>
				</ul>
			</div>
		</div>
	</div>
</div> -->



<!--<a href="tel:+496170961709" class="common-btn-customer-care common-btn-customer-care-fixed st">
	<div class="position-relative">
	<img src="assets/images/icon/icon-customer-care.svg" alt="icon-customer-care" class="icon-customer-care-img" />
	<p class="p-14 text-white">Customer Care</p>
	<p class="p-16 text-white">+91 22 39019400</p>
</div>
</a>-->

<footer class="common-footer">
	<div class="container">
		<div class="row align-items-center text-center">
			<div class="col-sm-12">
				<button data-toggle="modal" data-target="#modal-disclaimer" class="btn common-btn-disclaimer">
					Disclaimer
				</button>
			</div>
		</div>
	</div>
</footer>



<div class="modal fade common-modal" id="thankYouModal"  tabindex="-1"  style="z-index: 9999 !important; ">
	<div class="modal-dialog modal-sm modal-dialog-centered" style="max-width: 415px;">
		<div class="modal-content">
			<div class="modal-body text-center">
				<a class="icon-modal-close" data-dismiss="modal">
					<img src="assets/images/icon/icon-modal-close.svg" alt="icon-modal-close"
						 class="icon-modal-close-img" />
				</a>
				<div class="common-modal-inner" style="margin-top: 30px; margin-bottom: 30px;">
					<img data-dismiss="modal" src="assets/images/icon/icon-success.svg" alt="icon-success" class="icon-verify-account">
					<p class="p-16 mt10 font-weight-500">Thank you. One of our executives will get in touch with you soon.</p>
				
				</div>
			</div>
		</div>
	</div>
</div>

